import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon_message_clear",
  "use": "icon-icon_message_clear-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 14\" id=\"icon-icon_message_clear\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h14v14H0z\" /><path d=\"M12 7V4.286H8.25V2h-2.5v2.286H2V7h10Zm.4 1.6v3.8a.6.6 0 0 1-.6.6h-6V9.4H4.6V13H2.2a.6.6 0 0 1-.6-.6V8.6H1V4a.6.6 0 0 1 .6-.6h3V1.6a.6.6 0 0 1 .6-.6h3.6a.6.6 0 0 1 .6.6v1.8h3a.6.6 0 0 1 .6.6v4.6h-.6Z\" fill=\"#93949D\" fill-rule=\"nonzero\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol